module.exports = __webpack_public_path__ + "img/search.e63a44dc.svg";